import React, { useState } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import Select from "../../atoms/input/Select";
import { stateOptions } from "../../../static";
import { isShortCutCheckModalOpenState } from "../../../recoil/admin/examRoom";
import RaterShortCutModal from "./RaterShortCutModal";
import { useNavigate, useParams } from "react-router-dom";
import doubleArrowImg from "../../img/admin/pagenation-double-arrow.svg";
import arrowImg from "../../img/admin/pagenation-arrow.svg";
import useEvaluationActions from "../../../api/hooks/rater/evaluation";
import { useMutation, useQuery } from "@tanstack/react-query";
import { raterQuestionStartState } from "../../../recoil/rater/evaluation";

const RaterQusetion = () => {
  const navigate = useNavigate();
  const setShortCutCheckModalOpen = useSetRecoilState(
    isShortCutCheckModalOpenState
  );

  const [isRaterQuestionStart, setRaterQuestionStart] = useRecoilState(
    raterQuestionStartState
  );

  const [isExamData, setExamData] = useState({});

  const { room_sn } = useParams();

  const [isSearchRequire, setSearchRequire] = useState({
    index: 1,
    count: 10,
    criteria: "all",
  });

  const [isIndexList, setIndexList] = useState([]);

  console.log("room_sn :", room_sn);

  const evaluationActions = useEvaluationActions();

  const { data: evaluationList } = useQuery({
    queryKey: ["getEvaluationDetail", room_sn, isSearchRequire],
    queryFn: () =>
      evaluationActions.getEvaluationDetail({
        room_sn: room_sn,
        index: isSearchRequire.index,
        count: isSearchRequire.count,
        criteria: isSearchRequire.criteria,
      }),
    onSuccess: (result) => {
      console.log("RaterQusetion result :", result);
    },
    onError: (result) => {
      console.log("RaterQusetion error result :", result);
    },
  });
  console.log("evaluationList", evaluationList);

  // mutation.mutate({room_sn: room_sn})

  return (
    <div className="admin_content">
      <div className="content-title">
        <p className="exam">시험실</p>
      </div>
      <div className="content-cont">
        <div className="container">
          <div className="tab-title">
            <ul className="nav nav-tabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button className="nav-link active">시험실 목록</button>
              </li>
            </ul>
          </div>
          <div className="tab-content" id="myTabContent">
            <div className="tab-pane fade show active">
              <div className="tab-title flex">
                <p style={{ marginBottom: "1.125rem" }}>평가자</p>
                <div style={{ marginBottom: "10px" }}>
                  <button
                    className="btn-custom b-btn"
                    onClick={() => {
                      // setShortCutCheckModalOpen(true);
                      navigate(`/rater/examroom/${room_sn}`);
                      // if (isRaterQuestionStart) {
                      //   navigate(`/rater/examroom/${room_sn}`);
                      // } else {
                      //   alert("평가를 이미 완료했습니다.");
                      // }
                    }}
                  >
                    평가바로가기
                  </button>
                  {/* <Select
                    placeholder="전체"
                    options={stateOptions}
                    style={{ width: "170px" }}
                    className="select-sort"
                    onChange={(e) => {
                      console.log("변경");
                      console.log(e.target.value);

                      setSearchRequire({
                        ...isSearchRequire,
                        criteria: e.target.value,
                      });
                    }}
                  /> */}
                </div>
              </div>
              {/*<div className="overflow-scroll" style={{ maxHeight: "460px" }}>*/}
              <div>
                <table className="rater-table">
                  <tbody>
                    <tr>
                      <th>번호</th>
                      <th>문항</th>
                      <th>평가상태</th>
                      <th>수정</th>
                    </tr>
                    {evaluationList?.data?.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td>{data.sn}</td>
                          <td>{data.title}</td>
                          <td>재평가</td>
                          <td>
                            <button
                              type="button"
                              className="insert-modalbtn"
                              style={{ margin: "16px 0" }}
                              onClick={() => {
                                setExamData({
                                  ...isExamData,
                                  sn: data.sn,
                                  questionNumber: data.question_number,
                                  result1: data.result1,
                                  result2: data.result2,
                                  result3: data.result3,
                                  result4: data.result4,
                                  otherResult1: data.otherResult1,
                                  otherResult2: data.otherResult2,
                                  otherResult3: data.otherResult3,
                                  otherResult4: data.otherResult4,
                                });
                                setShortCutCheckModalOpen(true);
                              }}
                            ></button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <RaterShortCutModal examData={isExamData} setExamData={setExamData} />
    </div>
  );
};

export default RaterQusetion;
